<template>
    <div
        class="md-hero standard"
        :class="[
            `banner-with-${searchStyle}`,
            agreementData && agreementData.agreement ? 'has-agreement' : ''
        ]"
        :style="{ paddingBottom: marginBottom }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
        >
            <media-content
                :class="[
                    `media-content-${searchStyle}`,
                    partialMaskOption.show ? 'show-mask' : ''
                ]"
                :type="contentType"
                :title="title"
                :subTitle="subTitle"
                :titlePic="titlePic"
                :imgAlign="imgAlign"
                :showShadow="showShadow"
                :layout="searchBarLayout"
                class="row2column"
                :style="{ '--partail-mask-color': partialMaskOption.color }"
            >
                <template #info>
                    <div
                        v-if="useType === 'video'"
                        class="play-video"
                        @click.stop="doVideoPlay"
                    ></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div class="media-content-box" @click="avoidEmitMedia">
                    <component
                        :is="searchBar"
                        v-if="searchStyle === 'search-bar'"
                        :needSearchCondition="true"
                        :configFilter="configFilter"
                        :placeholder="searchbarPlaceholder"
                        :submitText="computedSearchBtnText"
                        :class="[
                            searchBarLayout,
                            partialMaskOption.show ? 'show-mask' : ''
                        ]"
                        class="row2column"
                        :agreementData="agreementData"
                    >
                    </component>
                    <search-group
                        v-if="searchStyle === 'search-group'"
                        :needSearchCondition="false"
                        :searchGroupTabs="searchGroupTabs"
                        :searchGroupConfig="searchGroupConfig"
                        :nameType="nameType"
                        :nameRequired="nameRequired"
                        :phoneRequired="phoneRequired"
                        :class="[
                            searchBarLayout,
                            partialMaskOption.show ? 'show-mask' : ''
                        ]"
                        class="row2column"
                        :agreementData="agreementData"
                    ></search-group>
                    <banner-button
                        v-if="searchStyle === 'search-btn'"
                        :buttons="buttons"
                        :class="searchBarLayout"
                        class="row2column"
                    >
                    </banner-button>
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import mixinsSearchBar from './mixins-search-bar';
import MediaContent from '../../../components/media-content.vue';
import BannerButton from '../../../components/banner-button.vue';
import SearchGroup from './search-group.vue';

export default {
    mixins: [common, mixinsSearchBar],
    data: function() {
        return {
            searchBarMaskOption: {
                show: false,
                color: null
            },
            searchGroupMaskOption: {
                show: false,
                color: null
            }
        };
    },
    components: {
        MediaContent,
        BannerButton,
        SearchGroup
    },
    computed: {
        partialMaskOption() {
            let option = {
                show: false
            };
            if (this.searchStyle === 'search-bar') {
                option = Object.assign(option, this.searchBarMaskOption);
            }
            if (this.searchStyle === 'search-group') {
                option = Object.assign(option, this.searchGroupMaskOption);
            }
            return option;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

@mixin title-text {
    .title-text {
        .media-title {
            font-size: 30px;
            line-height: 36px;
        }

        .media-subtitle {
            font-size: 20px;
        }
    }
}

@mixin search-by-section {
    .search-by-section {
        border-bottom: 1px solid var(--color-border);

        .search-category {
            box-shadow: none;

            .keyword-submit {
                @include color-button-hover();
                min-width: 0;
                @include color-button();
                .search-text {
                    display: none;
                }
            }
        }
    }
}

.md-hero.standard {
    &.banner-with-search-bar {
        @include media-800 {
            margin-bottom: 52px;
            &.has-agreement {
                margin-bottom: 100px;
            }

            .media-content {
                position: static;

                @include title-text;

                .search-bar {
                    position: absolute;
                    padding: 0 15px;
                    top: 100%;
                    margin-top: 0;
                    left: 0px;
                    @include search-by-section;
                    .search-by-section {
                        .search-category {
                            .keyword-submit {
                                color: var(--color-holder);
                                background-color: white;
                                &:hover {
                                    background-color: white;
                                }

                                .search-text {
                                    display: none;
                                }
                            }
                        }
                    }

                    .condition-search {
                        display: none;
                    }
                }
            }
        }
    }

    &.banner-with-search-group {
        @mixin media-content_column {
            &.show-mask {
                .media-info {
                    &:before {
                        height: calc(100% + 55px);
                        @include media-800 {
                            height: 100%;
                            min-height: 80px;
                        }
                    }
                }
            }
        }
        .media-content.column {
            @include media-content_column;
        }
        @include media-1080 {
            .media-content.row2column {
                @include media-content_column;
            }
        }
        @include media-800 {
            margin-bottom: 87px;
            &.has-agreement {
                margin-bottom: 135px;
            }

            .media-content {
                position: static;

                @include title-text;
                @include search-by-section;

                .search-group {
                    position: absolute;
                    top: 100%;
                    left: 0px;
                    .tab-header {
                        &.mobile {
                            display: flex;
                            height: 40px;

                            .item {
                                padding: 0 20px;
                                margin-right: 0;
                                line-height: 36px;
                                text-align: center;
                                border-bottom: solid 4px transparent;
                                text-shadow: none;
                                color: #515666;
                                &.active {
                                    @include color-theme();
                                    font-family: var(--font-medium);
                                    @include color-theme('border-color');
                                }
                            }
                        }
                    }

                    .tab-body {
                        .tab-content {
                            height: 47px;
                            border: 1px solid var(--color-border);
                            .search-by-section {
                                height: 45px;
                                border-bottom: 0;
                                .search-category {
                                    height: 100%;
                                    .keyword-submit {
                                        color: #c6c8d1;
                                        background-color: white;
                                        width: 41px;
                                        padding: 0 1px 0 0;
                                        line-height: 44px;
                                        .icon-search {
                                            margin-right: 0;
                                        }
                                    }
                                }
                            }

                            .address-input {
                                box-shadow: none;

                                .left-box {
                                    height: 100%;

                                    input {
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                }

                .tab-header {
                    display: none;

                    &.mobile {
                        display: block;

                        .item {
                            &.active::before {
                                height: 0;
                            }
                        }
                    }
                }
            }
        }
        .media-content.column .media-info:before {
            height: calc(100% + 60px);
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                height: calc(100% + 60px);
            }
        }
        .address-input .submit-btn {
            width: 140px;
        }
    }

    &.banner-with-search-btn {
        .banner-button {
            width: 100%;
            flex-direction: row;
            justify-content: center;
            &.count-4 {
                max-width: 800px;
            }
            @include media-min-1080 {
                &.row {
                    // width: 50%;
                    flex-direction: column;
                    align-items: flex-end;
                    .btn-item {
                        width: 400px;
                    }
                }
            }
            .btn-item {
                padding: 0 15px;
                min-width: 240px;
                margin: 30px 5px 0;
                @include media-1080 {
                    min-width: 168px;
                    padding: 0 10px;
                    height: 32px;
                    line-height: 30px;
                    text-shadow: none;
                }
                &:first-child {
                    background-color: var(--mg-button-background);
                    border-color: var(--mg-button-background);
                }
            }
            @include media-800 {
                display: inline-block;
                width: auto;
                max-width: 100%;
                .btn-item {
                    width: 100%;
                    margin: 20px 0 0;
                    min-width: 154px;
                    height: 26px;
                    line-height: 24px;
                }
            }
        }
        .media-content.column .media-info:before {
            content: none;
        }
        @include media-1080 {
            .media-content.row2column .media-info:before {
                content: none;
            }
        }
        .media-content-box {
            text-align: center;
        }
    }

    .media-content {
        width: 1320px;
        max-width: 85%;
        z-index: calc(var(--level-sublow) + 1);
        @mixin media-content_column {
            width: 840px;
            &.show-mask {
                .media-info {
                    position: relative;
                    &:before {
                        content: '';
                        background-color: var(
                            --partail-mask-color,
                            rgba(255, 255, 255, 0.2)
                        );
                        height: calc(100% + 30px);
                        width: calc(100% + 54px);
                        position: absolute;
                        top: 30px;
                        left: -27px;
                        z-index: -1;
                        @include media-800 {
                            height: 100%;
                            width: 100%;
                            top: 18px;
                            left: 0;
                        }
                    }
                }
            }
        }
        &.column {
            @include media-content_column;
        }
        @include media-1080 {
            &.row2column {
                @include media-content_column;
            }
        }

        .media-info {
            width: 100%;
            max-width: 100%;
        }
        .title-text {
            padding-top: 0;
            .media-title {
                word-break: break-word;
                text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
            }
            .media-subtitle {
                margin-top: 15px;
                text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                overflow: hidden;
            }
            .media-shadow {
                background: hsla(0, 0%, 100%, 0.2);
                top: 32px;
                width: 840px;
                height: calc(100% + 21px);
                max-width: 110%;
            }
        }
        &.media-content-search-btn,
        &.media-content-search-group {
            .title-text .media-shadow {
                display: none;
            }
        }
        @include media-1080 {
            max-width: calc(100% - 80px);
            .title-text {
                .media-title {
                    font-size: 38px;
                    line-height: 1.2;
                }
                .media-subtitle {
                    font-size: 17px;
                }
            }
        }

        @include media-600 {
            max-width: calc(100% - 40px);
            .title-text {
                padding: 0;
                .media-title {
                    font-size: 24px;
                    line-height: 26px;
                }
                .media-subtitle {
                    width: 254px;
                    margin: 8px auto 0;
                    font-size: 14px;
                }
                .media-shadow {
                    width: 300px;
                    top: 16px;
                }
            }
            .banner-button {
                margin-top: 18px;
            }
        }
    }
    .banner-video + .media-content {
        .title-text .media-shadow {
            display: none;
        }
        @include media-min-1080 {
            &.row {
                .play-video {
                    margin: 10px auto;
                }
            }
        }
        .play-video {
            margin: 10px auto 10px;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site3/images/play.png)
                no-repeat;
            background-size: cover;
            cursor: pointer;
            pointer-events: all;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content,
    .banner-video.is-play + .media-content {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .column .media-content-box {
        width: 100%;
    }
    @include media-1080 {
        .row2column .media-content-box {
            width: 100%;
        }
    }
    @include media-min-1080 {
        .row .media-content-box {
            width: 50%;
        }
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
    .swiper-horizontal > .swiper-pagination-bullets {
        bottom: 20px;
        .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-left: 6px;
            margin-right: 6px;
            background-color: white;
            opacity: 0.5;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
}
</style>
